import { v4 as uuidv4 } from 'uuid'
import { globalState } from '@codeleap/store'
import { getFirebase } from '../../../services/firebaseApp'
import { LocalStorageKeys } from '../../../app/constants'

const anonId = globalState({ id: null }, { persistKey: LocalStorageKeys.ANON_ID })

const getAnonId = () => {
  const currentId = anonId.get().id

  if (currentId) return currentId

  const newId = String(uuidv4())
  anonId.set({ id: newId })

  return newId
}

export const anonUserMiddleware = async (req) => {
  if (!req.injectAnonymousUser) return req

  const firebase = await getFirebase()
  const user = firebase.auth().currentUser

  const anonymousId = getAnonId()

  req.headers.set('x-uid', user?.uid ?? anonymousId)
  req.headers.set('X-AnonId', anonymousId)

  return req
}
